import React from 'react';
export function ButtonMinWidthElement(props) {
    const { minWidth } = props;
    if (!minWidth) {
        return null;
    }
    return (React.createElement("img", { height: "1", style: {
            display: 'block',
            width: `${minWidth}!important`,
            height: '1px',
            maxWidth: '100%!important',
            maxHeight: '1px',
        }, src: "https://static.wixstatic.com/media/8f5152_9c9b518c839548d68838a8d097857b62~mv2.gif", alt: "" }));
}
//# sourceMappingURL=button-min-width-element.js.map